import React, { useEffect, useRef } from 'react';
import { TimelineMax, Linear } from 'gsap/TweenMax';

import calculating from '../../assets/media/reliability-calculator/calculating.svg';

const Step10 = () => {
  const dotsRef = useRef([]);

  useEffect(() => {
    const timeline = new TimelineMax({ repeat: -1, yoyo: true });

    timeline.staggerTo(
      dotsRef.current,
      0.5,
      {
        opacity: 1,
        ease: Linear.easeNone,
      },
      0.25
    );
  }, []);

  return (
    <div className="reliabilityCalculator__cell u-textCenter">
      <div className="hero-titleWrapper u-contrast">
        <h1 className="hero-title">
          Calculating your reliability
          <span
            className="reliabilityCalculator__dot"
            ref={element => {
              dotsRef.current[0] = element;
            }}
          >
            .
          </span>
          <span
            className="reliabilityCalculator__dot"
            ref={element => {
              dotsRef.current[1] = element;
            }}
          >
            .
          </span>
          <span
            className="reliabilityCalculator__dot"
            ref={element => {
              dotsRef.current[2] = element;
            }}
          >
            .
          </span>
        </h1>
      </div>
      <img src={calculating} alt="" />
    </div>
  );
};

export default Step10;
